export default class GetProposalRecordError extends Error {
}
